import { LegacyBox, LegacyText, styled } from '@gogame/components';

export const Header = styled(LegacyBox)`
  padding: 16px;
  min-height: 68px;
`;

export const Title = styled(LegacyText)`
  font-size: 16px;
`;

export const EmptyMessageBox = styled(LegacyBox)`
  padding: 16px;
  opacity: 0.6;
`;
